import { Chip, ChipProps } from '@material-ui/core';

export const TagChip = (props: ChipProps) => {
  return <Chip size="small" {...props} style={{ ...props.style, paddingTop: '2px' }} />;
};
